<template>
  <div class="row slim-grid-row mb-3 cursor-pointer">
    <div class="col-1" @click="toggleCheck">
      <div class="w-16px rounded border-2-green text-center delay mt-2px" :class="{'bg-green':local_item.is_checked}">
       <img src="../../../../assets/img/icon/correct-white.png" class="position-relative" width="10" style="margin-top: -15px" v-if="local_item.is_checked">
      </div>
    </div>
    <div class="col-11" @click="toggleCheck">
      <p class="mb-0 body-2-2 font-regular">{{local_item.data.name}}</p>
    </div>
    <div class="col-12 mt-2 pt-1" :class="{'pb-3 border-bottom': local_item.is_checked && index.index+1 != index.total}" v-if="local_item.is_checked">
      <p class="mb-0 bg-white body-2 text-12 font-regular px-1 delay label-active">{{$t('restaurant.note')}}</p>
      <input @input="sendBack" type="text" class="form-control body-2-2 text-14 mb-1" v-model="local_item.note">
    </div>
  </div>
</template>
<script>
  export default{
    props: ['item','index'],
    data(){
      return{
        local_item: {}
      }
    },
    created(){
      this.local_item = Object.assign({}, this.item)
    },
    methods:{
      toggleCheck(){
        this.local_item.is_checked = !this.local_item.is_checked
        this.local_item.note = (this.local_item.is_checked === false) ? '' : this.local_item.note
        this.sendBack()
      },
      sendBack(){
        this.$emit("toggleSelect",{
          data: this.local_item,
          index: this.index.index
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/be/mobile/specialRequestItem.vue